<template>
  <section class="hero">
    <div class="hero-inner">
      <div class="hero-eyebrow">{{ profile.motto }}</div>

      <div class="hero-grid">
        <div class="hero-left">
          <h1 class="hero-name">{{ profile.name }}</h1>
          <div class="hero-headline">{{ profile.headline }}</div>
          <a class="hero-org" :href="company.site" target="_blank" rel="noopener">
            {{ company.name }} &rarr;
          </a>
        </div>
        <div class="hero-right">
          <p class="hero-intro">{{ profile.intro }}</p>
          <div class="hero-actions">
            <a
              class="ui-btn ui-btn-primary"
              href="#solutions"
              @click.prevent="scrollTo('solutions')"
            >
              查看行业方案
            </a>
            <router-link class="ui-btn ui-btn-ghost" to="/nav">
              全部入口
            </router-link>
            <a
              class="ui-btn ui-btn-ghost"
              href="#contact"
              @click.prevent="scrollTo('contact')"
            >
              合作洽谈
            </a>
          </div>
        </div>
      </div>

      <div class="hero-stats">
        <div class="stat" v-for="s in stats" :key="s.label">
          <div class="stat-num">
            {{ s.value }}<span class="stat-suffix">{{ s.suffix }}</span>
          </div>
          <div class="stat-label">{{ s.label }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { profile, company } from "@/assets/js/profile";

export default {
  name: "HeroSection",
  data() {
    return {
      profile,
      company
    };
  },
  computed: {
    stats() {
      const list = [
        { value: profile.careerYears, suffix: "年", label: "从业" },
        { value: "1345", suffix: "篇", label: "CSDN 原创" },
        { value: "6.6", suffix: "万", label: "CSDN 粉丝" },
        { value: "348", suffix: "万", label: "文章累计阅读" }
      ];
      return list;
    }
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.hero {
  background: var(--bg);
  padding: 130px 24px 90px;
  border-bottom: 1px solid var(--border-soft);
}
.hero-inner {
  max-width: var(--maxw);
  margin: 0 auto;
}
.hero-eyebrow {
  font-size: 13px;
  letter-spacing: 3px;
  color: var(--accent);
  margin-bottom: 30px;
}
.hero-grid {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
}
.hero-left {
  flex: 1 1 420px;
  min-width: 300px;
}
.hero-name {
  font-size: 72px;
  line-height: 1.06;
  font-weight: 600;
  letter-spacing: -2px;
  color: var(--ink);
  margin: 0 0 18px;
}
.hero-headline {
  font-size: 23px;
  font-weight: 400;
  color: var(--ink-mid);
  letter-spacing: -0.3px;
}
.hero-org {
  display: inline-block;
  margin-top: 16px;
  font-size: 14.5px;
  color: var(--ink-soft);
}
.hero-org:hover {
  color: var(--accent);
}
.hero-right {
  flex: 0 1 430px;
  min-width: 300px;
  padding-bottom: 6px;
}
.hero-intro {
  font-size: 15.5px;
  line-height: 2;
  color: var(--ink-soft);
  margin: 0 0 26px;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
}
.hero-actions .ui-btn {
  margin: 0 10px 10px 0;
}
.hero-stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 72px;
  padding-top: 34px;
  border-top: 1px solid var(--border);
}
.stat {
  margin-right: 54px;
  margin-bottom: 10px;
}
.stat-num {
  font-size: 38px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -1px;
}
.stat-suffix {
  font-size: 15px;
  font-weight: 400;
  margin-left: 4px;
  color: var(--ink-faint);
}
.stat-label {
  font-size: 13.5px;
  color: var(--ink-soft);
  margin-top: 6px;
}

@media (max-width: 900px) {
  .hero-grid {
    align-items: flex-start;
  }
  .hero-right {
    margin-top: 34px;
  }
}
@media (max-width: 760px) {
  .hero {
    padding: 96px 20px 60px;
  }
  .hero-name {
    font-size: 46px;
    letter-spacing: -1px;
  }
  .hero-headline {
    font-size: 18px;
  }
  .hero-stats {
    margin-top: 46px;
  }
  .stat {
    flex: 0 0 45%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .stat-num {
    font-size: 29px;
  }
}
</style>
